module.exports = __webpack_public_path__ + "static/media/BMUB_NKI_logo@2x.00c6272e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/infopanel/BMUB_NKI_logo@2x.png
// module id = 468
// module chunks = 0